module.exports = __webpack_public_path__ + "img/mb_nav_mobil_banner.01eb51d.jpg";